import type { AccountSummaryResponse } from '@shared/types';
import { queryClient } from '../query-client';
import { billingKeys } from './billing.keys';

export function syncBillingBalance(balanceAfter?: number): void {
  if (typeof balanceAfter !== 'number') {
    return;
  }

  queryClient.setQueryData<AccountSummaryResponse | undefined>(billingKeys.account(), (current) => {
    if (!current) {
      return current;
    }

    return {
      ...current,
      account: {
        ...current.account,
        creditBalanceCached: balanceAfter,
      },
    };
  });
}
